import { Spin } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'

import { AuctionMonitoringRecord } from '../../../common/auctionMonitoringTypes'
import { usePropertyDetailAuctionQuery } from '../../../graphql/generated'
import { useAppSelector } from '../../../redux/hooks'
import { useAuctionLabelIds } from '../../utils/useAuctionLabelIds'
import { AuctionDetailDrawer } from '../AuctionDetailDrawer/AuctionDetailDrawer'
import AuctionMonitoringTable from '../AuctionMonitoringTable/AuctionMonitoringTable'
import { PageLayoutTabContainer } from '../PageLayoutTabContainer/PageLayoutTabContainer'

export interface PropertyDetailAuctionProps {
  propertyId: string
}

export const PropertyDetailAuction: FunctionComponent<PropertyDetailAuctionProps> =
  props => {
    const accountId = useAppSelector(state => state.myProfile.tenantId)
    const accountUserId = useAppSelector(state => state.myProfile.userId)
    const labelIds = useAuctionLabelIds()

    const [dataSource] = usePropertyDetailAuctionQuery({
      variables: {
        propertyId: props.propertyId,
        accountUserId,
        accountId,
        labelIds: labelIds.data,
      },
    })

    const data = useMemo(
      () =>
        dataSource?.data?.allAuctionProperties?.nodes.map(node => ({
          ...node?.auctionListingByAuctionId,
        })) as unknown as AuctionMonitoringRecord[],
      [dataSource?.data?.allAuctionProperties?.nodes]
    )

    return (
      <>
        <PageLayoutTabContainer>
          <Spin spinning={dataSource?.fetching || labelIds.fetching}>
            <AuctionMonitoringTable
              data={data}
              activePropertyId={props.propertyId}
              loading={dataSource?.fetching}
              viewType="propertyDetail"
            />
          </Spin>
        </PageLayoutTabContainer>
        <AuctionDetailDrawer />
      </>
    )
  }
